"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import actorIcon from "../../../../public/defaultavatar.webp";
import type { SearchPersonResult } from "@/types/search";
export default function SearchPersonCard(t0) {
  const $ = _c(17);
  const {
    person
  } = t0;
  const avatarUrl = person.avatar_url || person.Avatar_url;
  const t1 = `/crew/${person.uuid}`;
  const t2 = avatarUrl || actorIcon;
  const t3 = person.name_fa || person.name_en || "";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = <Image src={t2} alt={t3} fill={true} className="object-cover object-top" sizes="(max-width: 640px) 70px, (max-width: 768px) 90px, 90px" />;
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== person.role_name) {
    t5 = person.role_name && <><div className="absolute inset-0 rounded-[20px]" style={{
        background: "linear-gradient(156.58deg, rgba(217, 217, 217, 0) 17.61%, rgba(0, 36, 53, 0.8) 91.39%, #002435 96.08%)"
      }} /><div className="absolute bottom-0 left-0 right-0 z-10 p-2 md:p-3"><h3 className="truncate text-xs font-bold text-white md:text-[12px]">{person.role_name}</h3></div></>;
    $[3] = person.role_name;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <div className="relative w-full aspect-[140/160] overflow-hidden rounded-[20px]">{t4}{t5}</div>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = person.name_fa || person.name_en;
  let t8;
  if ($[8] !== person.name_fa || $[9] !== t7) {
    t8 = <p title={person.name_fa} className="mt-2 line-clamp-1 text-[12px] text-gray-400 md:text-[12px]">{t7}</p>;
    $[8] = person.name_fa;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <div className="w-[70px] sm:w-[90px] md:w-[90px]">{t6}{t8}</div>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t1 || $[15] !== t9) {
    t10 = <Link href={t1} className="block">{t9}</Link>;
    $[14] = t1;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}